export const GET_ACTIVE_BETS_START='GET_ACTIVE_BETS_START';
export const GET_ACTIVE_BETS_SUCCESS='GET_ACTIVE_BETS_SUCCESS';
export const GET_ACTIVE_BETS_FAIL='GET_ACTIVE_BETS_FAIL';

export const GET_34_ACTIVE_BETS_START='GET_34_ACTIVE_BETS_START';
export const GET_34_ACTIVE_BETS_SUCCESS='GET_34_ACTIVE_BETS_SUCCESS';
export const GET_34_ACTIVE_BETS_FAIL='GET_34_ACTIVE_BETS_FAIL';

